import React, { useState } from 'react';

const FAQItem = ({ id, question, answer, isActive, toggleFAQ }) => {
  return (
    <div className="card">
      <div className="card-header" id={`heading${id}`}>
        <h5 className="mb-0">
          <div
            className={`collapsed cr-pointer ${isActive ? 'active' : ''}`}
            onClick={() => toggleFAQ(id)}
            aria-expanded={isActive ? 'true' : 'false'}
            aria-controls={`collapse${id}`}
          >
            {question}
          </div>
        </h5>
      </div>
      <div
        id={`collapse${id}`}
        className={`collapse ${isActive ? 'show' : ''}`}
        aria-labelledby={`heading${id}`}
      >
        <div className="card-body">{answer}</div>
      </div>
    </div>
  );
};

const FAQSections = () => {
  const [activeFAQ, setActiveFAQ] = useState(null);

  const toggleFAQ = (id) => {
    setActiveFAQ((prev) => (prev === id ? null : id));
  };

  const faqs = [
    {
      id: 1,
      question: 'How can I make money from the app?',
      answer: 'You can earn money from your app by allowing your customers to do more of what usually produces revenue for your business. i.e. online food ordering, all of which can be paid for with a Credit/Debit Card.'
    },
    {
      id: 2,
      question: 'Will you help us to push our business web & mobile app to the app market?',
      answer: 'Yes, we will do our best to market your web & mobile app and make sure that we will follow the whole marketplace protocols and practices for getting your app accepted in the Apple’s App Store and Google Play Store.'
    },
    {
      id: 3,
      question: 'What can be some good features of the business app?',
      answer: 'Some of the best features of the business web & mobile app are user-friendly product, search option, online ordering, and online payment. As these are the most common ones, there are various other ones too that make the business app more useful.'
    },
    {
      id: 4,
      question: 'Why do businesses require web & mobile apps?',
      answer: 'There are a lot of benefits to using web & mobile apps for businesses. One is that it provides real-time access to users for streamlining the whole process among various stakeholders. However, one of the major and concrete benefits is providing high revenue for businesses.'
    },
    {
      id: 5,
      question: 'Why should I create an app for my business?',
      answer: 'Research by the National Business Association states that 83% of adults search for local businesses with the help of their smartphone. 75% use mobile devices to look up products before making a decision. These statistics support the idea of making your app for a business to benefit from.'
    },
    {
      id: 6,
      question: 'I have a single business. Would I gain any benefit from this app?',
      answer: 'Yes, This application platform will help you in managing orders that provide more time as well as energy for expanding your business.'
    },
    {
      id: 7,
      question: 'How can I manage my business products & orders?',
      answer: 'We will provide you the Admin web access to manage your business products & orders.'
    },
    {
      id: 8,
      question: 'I just started my business aggregator business. Should I invest in a web & mobile app?',
      answer: 'You shouldn’t see the investment into business app development services as either this or a growth option. Both are interdependent. A web & mobile app can be the best way to get orders online & grow your business.'
    },
  ];

  return (
    <section className="section-white small-padding-bottom" id="faq">
      <div className="container">
        <div className="row">
          <div className="col-md-6 margin-top-10">
            <img src="/assets/images/img4.jpg" className="width-100" alt="picture" />
          </div>
          <div className="col-md-6">
            <h3>Frequently Asked Questions</h3>
            <div className="accordion" id="accordionFAQ">
              {faqs.map((faq) => (
                <FAQItem
                  key={faq.id}
                  id={faq.id}
                  question={faq.question}
                  answer={faq.answer}
                  isActive={activeFAQ === faq.id}
                  toggleFAQ={toggleFAQ}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQSections;
